import { AppRootState } from 'app/store'

export const selectFilters = (state: AppRootState) => state.filters.tags
